import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import SVG from 'components/widgets/icons/svg';

// Utils
import { getFileOpenUrl } from 'utils/google-drive-utils';

const files = import.meta.glob('/app/assets/file-icons/*.png', {
  import: 'default',
  eager: true
});
const typeMap = {
  'vnd.google-apps.spreadsheet': 'sheet',
  'vnd.google-apps.document': 'doc',
  'vnd.google-apps.folder': 'folder',
  'vnd.google-apps.form': 'form',
  'vnd.google-apps.presentation': 'slide',
  'vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
  'vnd.openxmlformats-officedocument.presentationml.presentation': 'powerpoint',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
  'x-msdownload': 'exe',
  pdf: 'pdf',
  zip: 'zip',
  'vnd.jgraph.mxfile.realtime': 'drawio',
  image: 'image',
  text: 'text'
};

export default function DriveFile({ item, forSelect, onClick }) {
  const mimeType = item.mimeType || item.mimetype;
  const name = item.name || item.filename;
  const id = item.fileId || item.id;
  const [prefix, detail] = _.split(mimeType, '/');
  const type = prefix === 'application' ? _.get(typeMap, detail, 'file') : _.get(typeMap, prefix, 'file');

  const body = (
    <div>
      { type === 'folder' && <SVG src={`svg/file-${type}.svg`} /> }
      { type !== 'folder' && <img src={files[`/app/assets/file-icons/${type}.png`]} alt={type} /> }
      <span>{name}</span>
    </div>
  );

  if (forSelect) return <div className={`drive-file drive-file-${type}`}>{body}</div>;

  if (onClick) return <li className={`drive-file drive-file-${type}`} onClick={onClick}>{body}</li>;

  return (
    <li className={`drive-file drive-file-${type}`}>
      <a href={getFileOpenUrl(id)} target="_blank" className="unadorned">{body}</a>
    </li>
  );
}

DriveFile.propTypes = {
  item: PropTypes.object.isRequired,
  forSelect: PropTypes.bool,
  onClick: PropTypes.func
};
